import { css, jsx } from '@emotion/react';
import { Text } from '../../display/Text/Text.es.js';
import { Link } from '../../navigation/Link/Link.es.js';

const Styles = {
  ctaDisclaimer: css`
    margin: var(--zds-space-8) 0;
  `
};
const DisclaimerText = ({ color = "primary", termsLink = "https://zapier.com/tos", textType = "Body1", privacyLink = "https://zapier.com/privacy" }) => {
  const textColor = color === "primary" ? "GrayWarm9" : "PrimeWhite";
  return jsx(
    "div",
    { css: Styles.ctaDisclaimer, "data-zds": true },
    jsx(
      Text,
      { tag: "p", type: textType, color: textColor },
      "By signing up, you agree to Zapier’s",
      " ",
      jsx(Link, { href: termsLink, color }, "Terms of Service"),
      " ",
      "and",
      " ",
      jsx(Link, { href: privacyLink, color }, "Privacy Policy"),
      "."
    )
  );
};

export { DisclaimerText };
//# sourceMappingURL=DisclaimerText.es.js.map
